"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const _1 = require(".");
function default_1({ isSecondPayment, paymentDetail, whoAmI, paymentDetailDelivery, confirm, }) {
    if (isSecondPayment && paymentDetail.order_status_cd_id === 'ORDER_STATUS_01') {
        confirm({
            description: `${i18next_1.default.t('먼저 [ 결제하기 ] 완료 후 2차 결제 진행해 주세요')} :)`,
            cancellationButtonProps: { style: { display: 'none' } },
        });
        return false;
    }
    const isUserAgeCertified = (0, _1.checkAgeCertification)({
        paymentDetail,
        whoAmI,
        confirm,
    });
    const isUserRequirementsFulfilled = isUserAgeCertified &&
        (0, _1.checkInputRequirements)({
            paymentDetail,
            paymentDetailDelivery,
            isSecondPayment,
        });
    return isUserAgeCertified && isUserRequirementsFulfilled;
}
exports.default = default_1;
